import { NoParamEndpointConstructor, SingleParamEndpointConstructor } from 'interfaces/api.interfaces'

const baseUrl = '/prgm/dictionaries'

interface Endpoints {
  getAll: NoParamEndpointConstructor
  update: SingleParamEndpointConstructor
  create: NoParamEndpointConstructor
  remove: SingleParamEndpointConstructor
}

export const manualsEndpoints: Endpoints = {
  getAll: () => `${baseUrl}`,
  update: (id) => `${baseUrl}/${id}`,
  create: () => `${baseUrl}`,
  remove: (id) => `${baseUrl}/${id}`,
}
